import { getDeployEnv } from "@utils/deployEnv";

export const deployEnvConfig = getDeployEnv();
